import { useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

export default function DetailActions({ dramaId }: { dramaId: string }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [copied, setCopied] = useState(false);
  const fav = isFavorite(dramaId);

  async function handleShare() {
    try {
      const url = window.location.href;
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      <button
        type="button"
        onClick={() => toggleFavorite(dramaId)}
        className={`inline-flex items-center gap-2 h-10 px-5 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
          fav
            ? "bg-accent-500 text-background-50 hover:bg-accent-600"
            : "bg-background-50 border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-600"
        }`}
      >
        <i className={fav ? "ri-heart-3-fill text-lg" : "ri-heart-3-line text-lg"} />
        {fav ? "已收藏" : "收藏"}
      </button>

      <button
        type="button"
        onClick={handleShare}
        className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-background-50 border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-share-forward-line text-lg" />
        分享链接
      </button>

      {copied && (
        <span className="text-sm text-primary-600 flex items-center gap-1 animate-fade-in">
          <i className="ri-check-line" />
          链接已复制到剪贴板
        </span>
      )}
      <span className="text-xs text-foreground-400 w-full sm:w-auto">
        收藏保存在本地浏览器，刷新后依然保留
      </span>
    </div>
  );
}